/**
 * Custom functionality for About page.
 */

/* global jQuery */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

const form = require('../components/form-block');

// Set up slick slider for staff chips in mobile.
let 
    $window = $(window),
    $mySlider = $('.team-staff__wrap'),
    mySliderSettings = {
        centerMode:true,
        centerPadding:'105px',
        cssEase:'ease-out',
        infinite:true,
        mobileFirst:true,
        slidesToShow:1,
        swipeToSlide:true,
        // slidesToScroll:1,
        arrows:false,
        // adaptiveHeight:true,
        // responsive: [
        //     {
        //         breakpoint:767,
        //         settings: "unslick"
        //     }
        // ]
    };

function initStaffSlider() {
    console.log('ABOUT: initStaffSlider()');
    $mySlider.slick(mySliderSettings);
}

function initResizeWatcher() {
    console.log('ABOUT: initResizeWatcher()');

    $window.on('resize', function() {
        if ($window.width() >= 768) {
            console.log('ABOUT: tablet-v');
            if ($mySlider.hasClass('slick-initialized')) {
                console.log('ABOUT: UNSLICK');
                $mySlider.slick('unslick');
            }
            return
        }
        if (!$mySlider.hasClass('slick-initialized')) {
            console.log('ABOUT: SLICK');
            $mySlider.slick(mySliderSettings);
        }
    });
}

exports.init = function () {
    // Run init methods...
    let browserW = $(window).width();

    // Initialize slick slider if page opened in mobile view (< 768).
    if (browserW < 768) {
        initStaffSlider();
    }
    initResizeWatcher();
    form.init();
};